import CategoryModel from '../../../../models/v2/category/category.model';
import { NewsForgeRequestStatusTypes } from '../helpers/news-forge-requests.helper';

export interface INewsForgeTranslationContent {
	target_url: string | null;
	category: CategoryModel | null;
	original_content: ITextContent | null;
	translated_content: ITextContent | null;
}

export interface INewsForgePollingResponse {
	id: string | null;
}

export interface ITranslationResponse {
	status: NewsForgeRequestStatusTypes | null;
	message: string | null;
	data: IEditorialContent | null;
}

export interface IEditorialContent {
	original_content: ITextContent | null;
	translated_content: ITextContent | null;
}

export interface ITextContent {
	title: string | null;
	content: string | null;
}

export const initialNewsForgeState: INewsForgeTranslationContent = {
	target_url: null,
	category: null,
	original_content: null,
	translated_content: null,
};

export interface INewsForgeGeneratedArticle {
	title: string | null;
	content: string | null;
	category_id: string | null;
}
